import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { number, oneOf } from 'prop-types';
import styled, { css } from 'styled-components';
import theme from 'styled-theming';
import darken from 'polished/lib/color/darken';
import { TAB_VARIANTS } from './constants.js';
export { TAB_VARIANTS } from './constants.js';
import { Tabs, TabList, TabPanel } from '@reach/tabs';
export { Tab, TabPanels } from '@reach/tabs';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
const TabColorVariants = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n"])), _ref => {
  let {
    theme: {
      colors
    },
    variant
  } = _ref;
  switch (variant) {
    case TAB_VARIANTS.STANDARD:
      return "\n          border-color: ".concat(colors.surface, ";\n          background-color: ").concat(colors.surface, ";\n        ");
    case TAB_VARIANTS.PLAIN:
      return "\n          border-color: ".concat(colors.background, ";\n          background-color: ").concat(colors.background, ";\n        ");
    default:
      return "\n          border-color: ".concat(colors.surface, ";\n          background-color: ").concat(colors.surface, ";\n        ");
  }
});
const TabsStyled = /*#__PURE__*/styled(Tabs).withConfig({
  displayName: "tabs__TabsStyled",
  componentId: "sc-hy7wij-0"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  [data-reach-tab] {\n    all: unset;\n    flex: 1;\n    padding: ", ";\n    border-bottom: 1px solid\n      ", ";\n    background-color: ", ";\n    transition: ", ";\n\n    &:focus-visible {\n      box-shadow: ", ";\n    }\n\n    text-align: center;\n    line-height: 1;\n    color: ", ";\n    font-size: ", ";\n    font-weight: bold;\n    cursor: pointer;\n\n    &[aria-disabled] {\n      opacity: ", ";\n      cursor: default;\n      pointer-events: none;\n    }\n\n    ", "\n\n    ", " {\n      padding: ", ";\n      font-size: ", ";\n    }\n  }\n\n  [data-reach-tab-panels] {\n    ", "\n  }\n"])), _ref2 => {
  let {
    theme
  } = _ref2;
  return "".concat(theme.spacing.baseSpacing, " ").concat(theme.spacing.halfSpacing);
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return darken(0.195, theme.colors.accents.muted);
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return darken(0.05, theme.colors.accents.muted);
}, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.transitionsMs.default;
}, _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.boxShadows.focus;
}, _ref7 => {
  let {
    theme
  } = _ref7;
  return theme.colors.text;
}, _ref8 => {
  let {
    theme
  } = _ref8;
  return theme.fontSizes.xsmall;
}, _ref9 => {
  let {
    theme
  } = _ref9;
  return theme.opacities.disabled;
}, _ref10 => {
  let {
    defaultIndex
  } = _ref10;
  return defaultIndex >= 0 ? css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n            &:nth-child(", ") {\n              cursor: default;\n              ", "\n              z-index: 1;\n            }\n            &:not(:nth-child(", ")):hover {\n              color: currentColor;\n              background-color: ", ";\n\n              ", "\n            }\n          "])), defaultIndex + 1, TabColorVariants, defaultIndex + 1, _ref11 => {
    let {
      theme
    } = _ref11;
    return theme.colors.primary.main;
  }, _ref12 => {
    let {
      theme: {
        colors
      }
    } = _ref12;
    return theme('name', {
      pureGym: "background-color: ".concat(colors.brandAccents.softOrange)
    });
  }) : css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n            &[data-selected] {\n              cursor: default;\n              ", "\n              z-index: 1;\n            }\n\n            &:not([data-selected]):hover {\n              color: currentColor;\n              background-color: ", ";\n\n              ", "\n            }\n          "])), TabColorVariants, _ref13 => {
    let {
      theme
    } = _ref13;
    return theme.colors.primary.main;
  }, _ref14 => {
    let {
      theme: {
        colors
      }
    } = _ref14;
    return theme('name', {
      pureGym: "background-color: ".concat(colors.brandAccents.softOrange)
    });
  });
}, _ref15 => {
  let {
    theme
  } = _ref15;
  return theme.mediaQueries.md;
}, _ref16 => {
  let {
    theme
  } = _ref16;
  return "".concat(theme.spacing.threeQuarterSpacing, " ").concat(theme.spacing.baseSpacing);
}, _ref17 => {
  let {
    theme
  } = _ref17;
  return theme.fontSizes.standard;
}, TabColorVariants);
const TabListStyled = /*#__PURE__*/styled(TabList).withConfig({
  displayName: "tabs__TabListStyled",
  componentId: "sc-hy7wij-1"
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  column-gap: 1px;\n  background-color: ", ";\n"])), _ref18 => {
  let {
    theme
  } = _ref18;
  return darken(0.195, theme.colors.accents.muted);
});
const TabPanelStyled = /*#__PURE__*/styled(TabPanel).withConfig({
  displayName: "tabs__TabPanelStyled",
  componentId: "sc-hy7wij-2"
})(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  position: relative;\n  z-index: 1;\n  padding: ", ";\n\n  ", " {\n    padding: ", ";\n  }\n"])), _ref19 => {
  let {
    theme
  } = _ref19;
  return theme.spacing.baseSpacing;
}, _ref20 => {
  let {
    theme
  } = _ref20;
  return theme.mediaQueries.md;
}, _ref21 => {
  let {
    theme
  } = _ref21;
  return theme.spacing.doubleSpacing;
});
const TabsProps = {
  defaultIndex: number,
  variant: oneOf(Object.values(TAB_VARIANTS))
};
TabsStyled.propTypes = TabsProps;

export { TabListStyled as TabList, TabPanelStyled as TabPanel, TabsStyled as Tabs };
